import React, { forwardRef, useRef, useState, useEffect } from 'react';
import {
    Box,
    FormControl,
    FormLabel,
    Input,
    Text,
    Tooltip,
    Image,
    useToast,
} from '@chakra-ui/react';
import {BASE_URL} from "../../config";

const FileUploadInput = forwardRef(({ onFileSelect, isEditing = true, coverImage = '', coverImageName = '' }, ref) => {
    const toast = useToast();
    const inputRef = useRef(null);
    const [fileName, setFileName] = React.useState(coverImage);
    const [previewUrl, setPreviewUrl] = useState('');
    const baseURL = BASE_URL;

    useEffect(() => {
        if (coverImage && typeof coverImage === 'string') {
            const isFullUrl = coverImage.startsWith('http');
            setPreviewUrl(isFullUrl ? coverImage : `${baseURL}/${coverImage}`);
        }
    }, [coverImage]);

    const handleClick = () => {
        inputRef.current?.click();
    };

    const handleChange = (e) => {
        const file = e.target.files[0];
        const validTypes = ['image/jpeg', 'image/png'];
        if (file && !validTypes.includes(file.type)) {
            toast({ title: 'Nieprawidłowy format pliku', status: 'error' });
            return;
        }
        if (file) {
            setFileName(file.name);
            const localPreviewUrl = URL.createObjectURL(file);
            setPreviewUrl(localPreviewUrl);
            onFileSelect?.(file);
        }
    };

    return (
        <FormControl>
            <FormLabel fontWeight="400" fontFamily="Poppins">Zdjęcie okładkowe wydarzenia</FormLabel>
            <Tooltip
                label={<Image src={previewUrl} maxW="200px" border="1px solid #ccc" />}
                isDisabled={!previewUrl}
                hasArrow
                placement="right-start"
                bg="white"
                border="1px solid #ccc"
                p={2}
            >
                <Box
                    role="button"
                    as="div"
                    onClick={handleClick}
                    cursor="pointer"
                    border="1px solid #D9D9D9"
                    borderRadius="0"
                    w="full"
                    h="40px"
                    textAlign="left"
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    px="10px"
                    bg="white"
                >
                    {coverImageName || fileName || 'Wybierz plik'}
                    <Box as="span">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 13V14C1 14.7956 1.31607 15.5587 1.87868 16.1213C2.44129 16.6839 3.20435 17 4 17H14C14.7956 17 15.5587 16.6839 16.1213 16.1213C16.6839 15.5587 17 14.7956 17 14V13M13 5L9 1M9 1L5 5M9 1V13" stroke="#363636" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </Box>
                </Box>
            </Tooltip>
            <Input
                type="file"
                accept=".jpg,.png"
                display="none"
                ref={inputRef}
                onChange={handleChange}
                disabled={!isEditing}
            />
            <Text mt="1" fontSize="sm" color="gray.600">
                Akceptowane formaty: .jpg, .png. Sugerowany rozmiar: 1080 x 1080 pikseli.
            </Text>
        </FormControl>
    );
});

export default FileUploadInput;
